import AuthLayout from "../pages/AuthLayout";
import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

import Login from "../pages/Login/Login";
import Error403 from "../pages/Errors/403";

import roadSinistersPages from "./sinisterRoutes";
import invoicePages from "./invoiceRoutes";
import extranet from "./extranetRoutes";
import finance from "./financeRoutes";
import suppliesPages from "./suppliesRoutes";
import reports from "./reportsRoutes";
import userPages from "./userRoutes";
import mainPages from "./mainRoutes";

import purchasePages from "./purchaseRoutes";
import providerPages from "./providerRoutes";
import warehousePages from './warehouseRoutes'
import crewPages from "./crewRoutes";
import customerPages from "./customerRoutes";
import workplanPages from "./workplanRoutes";
import highwayPages from "./highwayRoutes";
import dynamicPages from "./dynamicRoutes";
import idealPages from "./idealRoutes";
import clientRoutes from "./clientRoutes";

/**
 * The routes
 *
 * @type {object} The routes
 */

const authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    // {
    //   path: "/register",
    //   name: "Register",
    //   component: Register,
    // },
    // {
    //   path: "/lock",
    //   name: "Lock",
    //   component: Lock,
    // },
  ],
};

const errorPages = {
  path: "/",
  component: DashboardLayout,
  name: "errorPages",
  icon: "bookmarks",
  children: [
    {
      path: "/error/403",
      name: "Access Denied",
      component: Error403,
    },
  ],
};

const publicPages = {
  path: "/",
  component: DashboardLayout,
  name: "publicPages",
};

export default [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/home",
    redirect: "/login",
  },
  authPages,
  errorPages,
  mainPages,
  userPages,
  publicPages,
  clientRoutes,
  roadSinistersPages,
  providerPages,
  warehousePages,
  purchasePages,
  highwayPages,
  customerPages,
  crewPages,
  suppliesPages,
  invoicePages,
  workplanPages,
  dynamicPages,
  reports,
  finance,
  extranet,
  idealPages,
  {
    path: "/*",
    redirect: "/login",
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js